module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-card-weather-42dc2536bd3c51144d5f7a45519b40e3.webp";